import React from 'react';

import {FormControlGroup} from 'app/general/forms';
import StateButton from 'app/general/widgets/StateButton';
import {gt} from 'app/utils/i18n';

import {WebHookEventType, WebHookSerializedType} from 'sweet-types';

interface HookEvent {
  label: string;
  value: WebHookEventType;
}

type DraftWebHookEventType = WebHookEventType | '';

export interface DraftWebHook
  extends Omit<
    WebHookSerializedType,
    | 'event'
    | 'url'
    | 'requests_count'
    | 'last_request_at'
    | 'is_last_request_successful'
  > {
  event: DraftWebHookEventType;
}

const EVENTS: Array<HookEvent> = [
  {label: 'Task Completed', value: 'task.completed'},
  {label: 'Task Overdue', value: 'task.overdue'},
  {label: 'Procedure version Approved', value: 'procedure.approved'},
  {label: 'Policy version Approved', value: 'policy.approved'},
  {label: 'Process version Approved', value: 'process.approved'},
];

type Props = {
  webhook: DraftWebHook;
  save: (
    event: WebHookEventType,
    target: string,
    is_active: boolean
  ) => Promise<unknown>;
};

export function EditableWebhook({webhook, save}: Props): JSX.Element {
  const [target, setTarget] = React.useState<string>(webhook.target);
  const [isActive, setActive] = React.useState<boolean>(webhook.is_active);
  const [event, setEvent] = React.useState<DraftWebHookEventType>(
    webhook.event
  );

  return (
    <div className="row py-2 border-bottom">
      <FormControlGroup
        className="align-self-start d-none d-sm-flex col-2 pr-0 mb-0 align-items-center justify-content-center"
        field="is_active"
      >
        <input
          style={{height: 30}}
          type="checkbox"
          checked={isActive}
          onChange={(event) => setActive(event.target.checked)}
        />
      </FormControlGroup>
      <FormControlGroup
        className="d-sm-none col-12 pr-0 d-flex"
        field="is_active"
      >
        <div className="form-check">
          <input
            className="form-check-input"
            id="webook-is-active"
            type="checkbox"
            checked={isActive}
            onChange={(event) => setActive(event.target.checked)}
          />
          <label className="form-check-label" htmlFor="webook-is-active">
            {gt('Active')}
          </label>
        </div>
      </FormControlGroup>
      <FormControlGroup
        className="col-12 col-sm-3 mb-sm-0 pr-sm-0"
        field="event"
      >
        <label className="d-sm-none">{gt('Event')}</label>
        <select
          className="form-control form-control-sm"
          value={event}
          onChange={(event) =>
            setEvent(event.target.value as DraftWebHookEventType)
          }
        >
          <option key={''} value={''}>
            {'----'}
          </option>
          {EVENTS.map((event) => (
            <option key={event.value} value={event.value}>
              {event.label}
            </option>
          ))}
        </select>
      </FormControlGroup>
      <FormControlGroup
        className="col-12 col-sm mb-sm-0 pr-sm-0"
        field="target"
      >
        <label className="d-sm-none">{gt('Target URL')}</label>
        <input
          type="text"
          className="form-control form-control-sm"
          value={target}
          placeholder={gt('Target URL')}
          onChange={(event) => setTarget(event.target.value)}
        />
      </FormControlGroup>
      <div className="col-auto ml-auto">
        <StateButton
          disabled={event === ''}
          onClick={() => {
            if (event !== '') {
              save(event, target, isActive);
            }
          }}
          className="btn btn-primary btn-sm"
        >
          {gt('Save')}
        </StateButton>
      </div>
    </div>
  );
}
